import { render, staticRenderFns } from "./FuncionarioPrincipal.vue?vue&type=template&id=9922c7bc&"
import script from "./FuncionarioPrincipal.vue?vue&type=script&lang=js&"
export * from "./FuncionarioPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports